/* =================== MINHA CONTA =================== */
jQuery(document).ready(function ($) {
  // Abre o modal de recuperaçao de senha
  $(".link-rec").on("click", function (e) {
    e.preventDefault();
    closeModal("modal-login");
    openModal("modal-recuperacao");
  });

  // Abre o modal de cadastro
  $(".open-cadastro").on("click", function (e) {
    e.preventDefault();
    const tipo = $(this).data("tipo");
    if (tipo) {
      $("#login-tipo").val(tipo);
      $("#cadastro-tipo").val(tipo);
    }
    closeModal("modal-login");
    openModal("modal-cadastro");
  });

  // Abre o modal de login
  $(".open-login").on("click", function (e) {
    e.preventDefault();
    const tipo = $(this).data("tipo");
    if (tipo) {
      $("#login-tipo").val(tipo);
      $("#cadastro-tipo").val(tipo);
    }
    closeModal("modal-cadastro");
    openModal("modal-login");
  });

  // Exibe a confirmação ao clicar no botão de remover
  $(".btn-confirm").on("click", function (e) {
    e.preventDefault();
    var idRemove = $(this).data("id");
    $("#id_remove").val(idRemove);
    openModal("modal-confirm");
  });

  // Exibe a confirmação ao clicar no botão de cancelar plano
  $(".btn-cancela").on("click", function (e) {
    e.preventDefault();
    var idCancela = $(this).data("id");
    $("#id_cancela").val(idCancela);
    openModal("modal-cancelar");
  });

  // TIPO DE CONTA DO LOCATARIO
  function validaTipoConta() {
    var tipo = $('input[name="tipo_cadastro"]:checked').val();
    if (tipo == "fisica") {
      $(".campo-cnpj").hide();
      $(".campo-cnpj input").prop("required", false);

      $(".campo-razao").hide();
      $(".campo-razao input").prop("required", false);

      $(".campo-rg").show();
      $(".campo-rg input").prop("required", true);

      $(".campo-cpf").show();
      $(".campo-cpf input").prop("required", true);

      $(".campo-pais").hide();
      $(".campo-pais select").prop("required", false);

      $(".campo-documentoestrangeiro").hide();
      $(".campo-documentoestrangeiro input").prop("required", false);

      $(".campo-postalcode").hide();
      $(".campo-postalcode input").prop("required", false);

      $(".campo-cep").show();
      $(".campo-cep input").prop("required", true);

      $(".campo-estado").show();
      $(".campo-estado select").prop("required", true);

      $(".campo-estadoestrangeiro").hide();
      $(".campo-estadoestrangeiro input").prop("required", false);

    } else if (tipo == "juridica") {
      $(".campo-cnpj").show();
      $(".campo-cnpj input").prop("required", true);

      $(".campo-razao").show();
      $(".campo-razao input").prop("required", true);

      $(".campo-rg").show();
      $(".campo-rg input").prop("required", true);
      
      $(".campo-cpf").show();
      $(".campo-cpf input").prop("required", true);

      $(".campo-pais").hide();
      $(".campo-pais select").prop("required", false);

      $(".campo-documentoestrangeiro").hide();
      $(".campo-documentoestrangeiro input").prop("required", false);

      $(".campo-postalcode").hide();
      $(".campo-postalcode input").prop("required", false);

      $(".campo-cep").show();
      $(".campo-cep input").prop("required", true);

      $(".campo-estado").show();
      $(".campo-estado select").prop("required", true);

      $(".campo-estadoestrangeiro").hide();
      $(".campo-estadoestrangeiro input").prop("required", false);

    } else if (tipo == "estrangeiro") {
      $(".campo-cnpj").hide();
      $(".campo-cnpj input").prop("required", false);

      $(".campo-razao").hide();
      $(".campo-razao input").prop("required", false);

      $(".campo-rg").hide();
      $(".campo-rg input").prop("required", false);

      $(".campo-cpf").hide();
      $(".campo-cpf input").prop("required", false);

      $(".campo-pais").show();
      $(".campo-pais select").prop("required", true);

      $(".campo-documentoestrangeiro").show();
      $(".campo-documentoestrangeiro input").prop("required", true);

      $(".campo-postalcode").show();
      $(".campo-postalcode input").prop("required", true);

      $(".campo-cep").hide();
      $(".campo-cep input").prop("required", false);

      $(".campo-estado").hide();
      $(".campo-estado select").prop("required", false);

      $(".campo-estadoestrangeiro").show();
      $(".campo-estadoestrangeiro input").prop("required", true);
    }
  }
  validaTipoConta();
  $('input[name="tipo_cadastro"]').on("change", function () {
    validaTipoConta();
  });

  // Exibe/Oculta os campos da forma de pagamento escolhida
  $('input[name="forma-pagamento"]').on("change", function () {
    $(".forma-pag-content").slideUp();
    $(".forma-pag-content .campo").prop("disabled", true);
    $(".forma-pag-content .campo").prop("required", false);

    $('.forma-pag-content[data-forma="' + $(this).val() + '"]').slideDown();
    $('.forma-pag-content[data-forma="' + $(this).val() + '"] .campo').prop(
      "disabled",
      false
    );
    $('.forma-pag-content[data-forma="' + $(this).val() + '"] .campo').prop(
      "required",
      true
    );
  });

  // TERMOS (LOCATARIOS E PROPRIETARIOS)
  $(".botao-gera-contrato").show();
  $(".escolha-contrato-proprietario").on("change", function () {
    if ($(this).find("option:selected").data("termo") != 1) {
      openModal("modal-termo-" + $(this).val());
      $(".botao-gera-contrato").hide();
    } else {
      $(".botao-gera-contrato").show();
    }
  });
  $(".refresh-button-contrato").on("click", function () {
    $(".botao-gera-contrato").show();
  });
  $(".refresh-pag").on("click", function () {
    location.reload();
  });
  $(".check-termos").on("click", function () {
    let url_contrato = $(this).data("reload");
    $.ajax({
      url: $(this).data("url"),
      beforeSend: function () {
        showLoading();
      },
      success: function (data) {
        console.log(data);
        if (data == "ok") {
          location.href = url_contrato;
        } else {
          showAlert(
            "Erro",
            "Não foi possível realizar essa operação.",
            "error"
          );
        }
      },
      error: function (xhr, type, exception) {
        volta_submit();
        showAlert("Erro", "Não foi possível realizar essa operação.", "error");
        console.log("ajax error response type " + type);
      },
    });
  });
});
